import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  position: fixed;
  border: 2px solid ${({ theme }) => theme.colors.text04}22;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  &&&.active {
    border-top: 2px solid ${({ theme }) => theme.colors.text04};
    animation: ${spin} 0.6s linear infinite;
  }
  &&&.inline {
    position: inherit;
    display: inline-block;
  }
  &&&.small {
    border-width: 2px;
    width: 20px;
    height: 20px;
    top: calc(50% - 10px);
    left: calc(50% - 10px);
  }
  &&&.medium {
    border-width: 4px;
    width: 40px;
    height: 40px;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
  }
  &&&.large {
    border-width: 8px;
    width: 80px;
    height: 80px;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
  }
`;
